import { render, staticRenderFns } from "./ReportSale.vue?vue&type=template&id=9640d344&scoped=true"
import script from "./ReportSale.vue?vue&type=script&lang=js"
export * from "./ReportSale.vue?vue&type=script&lang=js"
import style0 from "./ReportSale.vue?vue&type=style&index=0&id=9640d344&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9640d344",
  null
  
)

export default component.exports